import _ from 'lodash';

function parseSuggestions(categories, itemIds) {
  const result = [];
  if (_.isEmpty(itemIds)) return result;

  categories?.forEach((category) => {
    const items = category.items?.filter((i) => itemIds.includes(i.id));
    items?.forEach((item) => {
      result.push({
        category,
        item,
      });
    });
  });

  return result;
}

export { parseSuggestions };
